module.exports = __webpack_public_path__ + "static/media/07.99492839.jpg";